import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.219 22.344 4.809-9.06a.8.8 0 0 0 .088-.359v-6.95a.8.8 0 0 0-.035-.231c-.119-.372-.35-.69-.578-1.003l-.15-.207h5.197c-.05.072-.097.141-.131.185-.225.318-.46.65-.579 1.04a1 1 0 0 0-.03.216v6.95c0 .125.03.25.09.36l4.822 9.08c.397.688.46 1.341.178 1.885-.34.66-1.134 1.116-2.097 1.216h-9.672c-.887-.038-1.603-.404-1.96-1.004-.352-.596-.334-1.35.048-2.118m14.847-.722-4.722-8.888V6.116c.072-.15.212-.344.33-.51.348-.487.742-1.04.523-1.69q-.21-.624-1.047-.882A.8.8 0 0 0 17.925 3h-6.063a.8.8 0 0 0-.315.069c-.578.26-.785.64-.853.91-.172.652.237 1.215.571 1.668.116.162.247.34.316.475v6.612L6.85 21.641c-.616 1.25-.616 2.562 0 3.603C7.475 26.3 8.656 26.94 10.1 27h9.728l.072-.003c1.525-.147 2.781-.91 3.366-2.044.525-1.019.45-2.203-.2-3.331"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }